import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import moment from 'moment-timezone';

import Prompt from 'components/Prompt';
import { observable } from 'mobx';

const OpenPromptNotice = styled.p`
  font-size: 120%;

  text-align: center;

  & strong {
    white-space: nowrap;
  }
`;

const BillingNotice = styled.p`
  & strong {
    color: red;
    font-weight: bold;
  }
`;

function getBillingNotice(t, roundType) {
  const keys = [`billing_notice_${roundType}`, 'billing_notice'];
  for (const key of keys) {
    const result = t(key);
    if (result !== key && result.trim() !== '') return result;
  }
  return '';
}

@inject('app')
@observer
class OpenRoundConfirmation extends Component {
  @observable confirm = false;

  render() {
    const { sale, t, locale } = this.props;

    const duration =
      sale.round.definition.durationType === 'flexible'
        ? !!sale.round.definition.durationInDays
          ? moment.duration(sale.round.definition.durationInDays, 'days')
          : null
        : !!sale.round.definition.endsAt
          ? moment.duration(moment(sale.round.definition.endsAt) - moment())
          : null;

    var data = {
      ...{
        duration: !!duration ? duration.humanize(true) : null,
        date: moment(sale.round.definition.endsAt).format('dddd, ll'),
        time: moment(sale.round.definition.endsAt).format('LT'),
      },
      ...(sale.round.definition.type === 'sealed_bidding'
        ? {
            estimate: !!sale.round.definition.estimate
              ? sale.round.definition.estimate.toFormattedMoney(
                  locale,
                  this.props.app.currency.code
                )
              : t('No estimate'),
          }
        : {
            startPrice: !!sale.round.definition.startPrice
              ? sale.round.definition.startPrice.toFormattedMoney(
                  locale,
                  this.props.app.currency.code
                )
              : t('No starting price'),
          }),
      ...(sale.round.definition.startsAt &&
      moment(sale.round.definition.startsAt).isAfter(moment())
        ? {
            start: moment
              .duration(moment(sale.round.definition.startsAt) - moment())
              .humanize(true),
            startDate: moment(sale.round.definition.startsAt).format(
              'dddd, ll'
            ),
            startTime: moment(sale.round.definition.startsAt).format('LT'),
            biddingDuration: moment
              .duration(
                moment(sale.round.definition.endsAt) -
                  moment(sale.round.definition.startsAt)
              )
              .humanize(true),
          }
        : {}),
    };

    function getRoundType({ type, enableFlexibleBidding }) {
      switch (sale.round.definition.type) {
        case 'incremental_auction':
          return enableFlexibleBidding ? 'incremental_auction' : 'openBidding';
        case 'sealed_bidding':
          return 'sealedBidding';
        case 'open_bidding':
          return 'openBidding';

        default:
          return type;
      }
    }

    const durationInDays = !duration ? null : duration.asDays().toFixed(0); // days()
    const canOpen =
      sale.round.definition.type === 'simple_offer' ||
      duration === null ||
      duration.asMinutes() >= 0;

    const localizationKey = !canOpen
      ? 'open_round_info_invalid_duration'
      : [
          'open_round_info_notice',
          getRoundType(sale.round.definition),
          sale.round.definition.durationType,
          data.start ? 'withstart' : undefined,
        ]
          .filter(Boolean)
          .join('_');

    const haveToConfirm =
      !!durationInDays && (durationInDays < 1 || durationInDays > 14);
    const confirmationKey = durationInDays > 14 ? 'too_long' : 'today';

    return (
      <Prompt
        {...sale.ui.prompt}
        onSubmit={() => {
          if (haveToConfirm) {
            this.confirm = true;
            return;
          }
          return sale.ui.prompt.onSubmit();
        }}
        opened={sale.ui.prompt.opened}
        dialogProps={{ maxWidth: '500px' }}
        showPrimaryButton={canOpen}
        defaultButtonText={canOpen ? null : t('close')}
      >
        <Prompt
          {...sale.ui.prompt}
          opened={this.confirm}
          onSubmit={() => {
            this.confirm = false;
            return sale.ui.prompt.onSubmit();
          }}
          onClose={() => {
            this.confirm = false;
            return sale.ui.prompt.onClose();
          }}
          dialogProps={{ maxWidth: '500px' }}
        >
          <OpenPromptNotice
            dangerouslySetInnerHTML={{
              __html: t(`open_round_deadline_${confirmationKey}`, {
                durationInDays,
              }),
            }}
          ></OpenPromptNotice>
        </Prompt>

        <OpenPromptNotice
          dangerouslySetInnerHTML={{
            __html: t(localizationKey, data),
          }}
        ></OpenPromptNotice>

        {/* {canOpen && saleEdit.docs.length > 0 && (
          <Fragment>
            <div>
              {t('Cannot update documents for open round - documents uploaded')}
            </div>
            <ul>
              {saleEdit.docs.map((d) => (
                <li>
                  {d.short || d.full}{' '}
                  {d.details && (
                    <span>
                      {t('doc from')} {moment(d.details).format('ll')}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </Fragment>
        )}
        {canOpen && config.saleEditDocs && saleEdit.docs.length === 0 && (
          <div>
            {t('Cannot update documents for open round - no documents')}
          </div>
        )} */}

        {canOpen && sale.round.definition.number === 1 && (
          <BillingNotice
            dangerouslySetInnerHTML={{
              __html: getBillingNotice(t, sale.round.definition.type),
            }}
          ></BillingNotice>
        )}

        {canOpen && <div>{t('Do you want to open the round?')}</div>}
      </Prompt>
    );
  }
}

export default OpenRoundConfirmation;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Prompts/OpenRoundConfirmation.jsx